import 'bootstrap/dist/css/bootstrap.min.css'
import { useCallback, useEffect, useState } from 'react'

import {
  ArrowClockwise,
  ArrowCounterClockwise,
  CheckCircle,
  Eye,
  UserPlus,
  XCircle,
} from 'phosphor-react'
import {
  Col,
  Form,
  OverlayTrigger,
  Row,
  Tab,
  Table,
  Tabs,
  Tooltip,
} from 'react-bootstrap'
import { Search } from 'react-bootstrap-icons'
import { toast } from 'react-toastify'
import { Ask } from '../../../components/Ask/index.jsx'
import { CustomButton } from '../../../components/CustomButton/index.jsx'
import { CustomSpinner } from '../../../components/CustomSpinner/index.jsx'
import Navbar from '../../../components/navbar/navbar.jsx'
import { useOrdenation } from '../../../hooks/useOrdenation/index.js'
import WMSCodOperService from '../../../services/database/WMSCodOperService/index.js'
import WMSTipoOSService from '../../../services/database/WMSTipoOSService/index.js'
import WmsOsService from '../../../services/database/WmsOsService/index.js'
import { formatDate } from '../../../utils/formatDate.js'
import { getValue } from '../../../utils/getValue.js'
import { sendErrorApiMessage } from '../../../utils/sendErrorApiMessage.js'
import { ModalFunc } from './ModalFunc/index.jsx'
import { ModalInfo } from './ModalInfo/index.jsx'
import { generateServiceOrderPDF } from './generateServiceOrderPDF.js'
import { Container, Content, Group } from './styles.js'

function Os() {
  const [os, setOs] = useState([])
  const [isLoadingOs, setIsLoadingOs] = useState(true)
  const [activeTab, setActiveTab] = useState('A')
  const [osInfo, setOsInfo] = useState({})
  const [isModalOsInfoOpen, setIsModalOsInfoOpen] = useState(false)
  const [isReverseLoading, setIsReverseLoading] = useState({})
  const [selectedOs, setSelectedOs] = useState([])
  const [isModalFuncOpen, setIsModalFuncOpen] = useState(false)

  const [tiposOs, setTiposOs] = useState([])
  const [isTiposOsLoading, setIsTiposOsLoading] = useState(true)

  const [codigosOper, setCodigosOper] = useState([])
  const [isCodigosOperLoading, setIsCodigosOperLoading] = useState(true)

  const [search, setSearch] = useState({
    numos: '',
    numtrans: '',
    codoper: '',
    codenderecoorig: '',
    codendereco: '',
    sku: '',
    tipoos: '',
    status: activeTab,
  })

  const [isSearchLoading, setIsSearchLoading] = useState(false)

  const { filteredItems, Th, Paginate } = useOrdenation(os, 'numos')

  async function handleSearch() {
    try {
      setIsSearchLoading(true)

      const data = await WmsOsService.getBySearch(search)

      setOs(data)
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível fazer a pesquisa!')
    } finally {
      setIsSearchLoading(false)
    }
  }

  function handleChangeSearch(e) {
    const { name, value } = e.target

    setSearch((prevState) => ({
      ...prevState,
      [name]: value,
    }))
  }

  function onEnterKeyPress(e) {
    if (e.key === 'Enter') {
      handleSearch()
    }
  }

  function formatNumber(value) {
    if (value == null) return '0,00'

    return value.toLocaleString('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })
  }

  function handleSelectOs(o) {
    setOsInfo(o)
    setIsModalOsInfoOpen(true)
  }

  async function handleReverseOs(o, index) {
    try {
      setIsReverseLoading((prevState) => ({
        ...prevState,
        [index]: true,
      }))

      await WmsOsService.reverse(o.numos, localStorage.idusuario)

      await loadOs()

      toast.success('OS estornada com sucesso!')

      generateServiceOrderPDF({
        numos: o.numos,
        trans: o.numtrans,
        product: {
          sku: o.codprod,
          descricao: o.descricaoproduto,
          ruaorigem: o.ruaorigem,
          predioorigem: o.predioorigem,
          nivelorigem: o.nivelorigem,
          aptoorigem: o.aptoorigem,
          qt: o.qt,
          ruadestino: o.rua,
          prediodestino: o.predio,
          niveldestino: o.nivel,
          aptodestino: o.apto,
        },
      })
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível estornar a OS')
    } finally {
      setIsReverseLoading((prevState) => ({
        ...prevState,
        [index]: false,
      }))
    }
  }

  function areAllSelected(element) {
    return selectedOs.includes(element.numos)
  }

  async function loadTipoOs() {
    try {
      setIsTiposOsLoading(true)

      const data = await WMSTipoOSService.getAll()

      setTiposOs(data)
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível carregar os tipos de OS')
    } finally {
      setIsTiposOsLoading(false)
    }
  }

  async function loadCodigosOper() {
    try {
      setIsCodigosOperLoading(true)

      const data = await WMSCodOperService.getAll()

      setCodigosOper(data)
    } catch (err) {
      sendErrorApiMessage(
        err,
        'Não foi possível carregar os códigos de operação',
      )
    } finally {
      setIsCodigosOperLoading(false)
    }
  }

  const loadOs = useCallback(async () => {
    try {
      setIsLoadingOs(true)

      const data = await WmsOsService.getAll(activeTab)

      setOs(data)
      setSearch((prevState) => ({
        ...prevState,
        status: activeTab,
      }))
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível carregar as OS')
    } finally {
      setIsLoadingOs(false)
    }
  }, [activeTab])

  useEffect(() => {
    loadCodigosOper()
  }, [])

  useEffect(() => {
    loadTipoOs()
  }, [])

  useEffect(() => {
    loadOs()
  }, [loadOs])

  return (
    <>
      <Navbar />

      <Container className="mt-page">
        <h1 className="mb-4 text-center">Ordens de Serviço</h1>

        <Row className="mb-3">
          <Col>
            <Group>
              <CustomButton
                noMargin
                title="Atualizar"
                isLoading={isLoadingOs}
                isLoadingText="Atualizando..."
                onClick={loadOs}
              >
                <ArrowClockwise size={20} />
              </CustomButton>

              <CustomButton
                title="Atribuir à"
                onClick={() => setIsModalFuncOpen(true)}
                isDisabled={selectedOs.length === 0}
              >
                <UserPlus size={20} />
              </CustomButton>
            </Group>
          </Col>
        </Row>

        <Row
          className="mb-3"
          xs={8}
        >
          <Col>
            <Form.Label>ID</Form.Label>

            <Form.Control
              name="numos"
              value={search.numos}
              onChange={handleChangeSearch}
              onKeyDown={onEnterKeyPress}
            />
          </Col>

          <Col>
            <Form.Label>Trans.</Form.Label>

            <Form.Control
              name="numtrans"
              value={search.numtrans}
              onChange={handleChangeSearch}
              onKeyDown={onEnterKeyPress}
            />
          </Col>

          <Col>
            <Form.Label>
              Tipo Oper. {isCodigosOperLoading && <CustomSpinner size={15} />}
            </Form.Label>

            <Form.Select
              name="codoper"
              value={search.codoper}
              onChange={handleChangeSearch}
              disabled={isCodigosOperLoading}
            >
              <option value="">
                {isCodigosOperLoading ? 'Carregando...' : 'Selecione'}
              </option>

              {codigosOper.map((codigoOper) => (
                <option value={codigoOper.id}>{codigoOper.descricao}</option>
              ))}
            </Form.Select>
          </Col>

          <Col>
            <Form.Label>End. de Origem</Form.Label>

            <Form.Control
              name="codenderecoorig"
              value={search.codenderecoorig}
              onChange={handleChangeSearch}
              onKeyDown={onEnterKeyPress}
            />
          </Col>

          <Col>
            <Form.Label>End. de Destino</Form.Label>

            <Form.Control
              name="codendereco"
              value={search.codendereco}
              onChange={handleChangeSearch}
              onKeyDown={onEnterKeyPress}
            />
          </Col>

          <Col>
            <Form.Label>SKU</Form.Label>

            <Form.Control
              name="sku"
              value={search.sku}
              onChange={handleChangeSearch}
              onKeyDown={onEnterKeyPress}
            />
          </Col>

          <Col>
            <Form.Label>
              Tipo OS {isTiposOsLoading && <CustomSpinner size={15} />}
            </Form.Label>

            <Form.Select
              name="tipoos"
              value={search.tipoos}
              onChange={handleChangeSearch}
              disabled={isTiposOsLoading}
            >
              <option value="">
                {isTiposOsLoading ? 'Carregando...' : 'Selecione'}
              </option>

              {tiposOs.map((tipoOs) => (
                <option value={tipoOs.id}>{tipoOs.descricao}</option>
              ))}
            </Form.Select>
          </Col>

          <Col>
            <div
              style={{
                minHeight: '100%',
                display: 'flex',
                alignItems: 'flex-end',
              }}
            >
              <CustomButton
                noMargin
                title="Pesquisar"
                onClick={handleSearch}
                isLoading={isSearchLoading}
                isLoadingText="Pesquisando..."
              >
                <Search />
              </CustomButton>
            </div>
          </Col>
        </Row>

        <Tabs
          defaultActiveKey={activeTab}
          className="mb-3"
          onSelect={setActiveTab}
          transition={false}
        >
          <Tab
            eventKey="A"
            title="Abertas"
          />

          <Tab
            eventKey="I"
            title="Iniciadas"
          />

          <Tab
            eventKey="E"
            title="Estornadas"
          />

          <Tab
            eventKey="F"
            title="Finalizadas"
          />
        </Tabs>

        {isLoadingOs ? (
          <Content>
            <CustomSpinner size={64} />
          </Content>
        ) : os.length === 0 ? (
          <p>Sem dados disponíveis</p>
        ) : (
          <>
            <Table
              hover
              striped
              borderless
              responsive
            >
              <thead>
                <tr>
                  <th>
                    <Form.Check
                      checked={
                        filteredItems.length > 0 &&
                        filteredItems.every(areAllSelected)
                      }
                      disabled={filteredItems.length === 0}
                      onChange={(e) => {
                        if (e.target.checked) {
                          for (const o of os) {
                            setSelectedOs((prevState) => [
                              ...prevState,
                              o.numos,
                            ])
                          }
                        } else {
                          setSelectedOs([])
                        }
                      }}
                    />
                  </th>

                  <Th
                    label="ID"
                    value="numos"
                  />

                  <Th
                    label="Trans."
                    value="numtrans"
                  />

                  <Th
                    label="Tipo Oper."
                    value="descricaooperacao"
                  />

                  <Th
                    label="Orig."
                    value="codenderecoorig"
                  />

                  <Th
                    label="Dest."
                    value="codendereco"
                  />

                  <Th
                    label="SKU"
                    value="codprod"
                  />

                  <Th
                    label="Tipo OS"
                    value="tipoos"
                  />

                  <Th
                    label="Qtd"
                    value="qt"
                  />

                  <Th
                    label="Data"
                    value="data"
                  />

                  <Th label="Atr. à" />
                  <Th label="Obs" />
                  <Th label="Estornado" />
                  <Th label="Ações" />
                </tr>
              </thead>

              <tbody>
                {filteredItems.map((o, i) => (
                  <tr key={o.id_mov_pend}>
                    <td>
                      <Form.Check
                        checked={selectedOs.includes(o.numos)}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setSelectedOs((prevState) => [
                              ...prevState,
                              o.numos,
                            ])
                          } else {
                            setSelectedOs((prevState) =>
                              prevState.filter((numos) => numos !== o.numos),
                            )
                          }
                        }}
                      />
                    </td>
                    <td>{getValue(o.numos)}</td>
                    <td>{getValue(o.numtrans)}</td>
                    <td>{getValue(o.descricao_operacao)}</td>
                    <td>{getValue(o.endereco_origem)}</td>
                    <td>{getValue(o.endereco_destino)}</td>
                    <td>{getValue(o.sku)}</td>
                    <td>{getValue(o.descricao_tipoos)}</td>
                    <td>{formatNumber(o.qt) || 'N/I'}</td>
                    <td>{formatDate(o.data) || 'N/I'}</td>
                    <td>{getValue(o.funcionario_os)}</td>
                    <td>{getValue(o.obs)}</td>
                    <td>
                      {o.status == 'E' ? (
                        <OverlayTrigger
                          overlay={
                            <Tooltip>
                              {`Estornado em ${formatDate(o.dataestorno)} às ${formatDate(o.horaestorno, 'HH:mm')} por ${o.funcionario_estorno}`}
                            </Tooltip>
                          }
                        >
                          <CheckCircle
                            size={24}
                            weight="fill"
                            color="#28b463 "
                          />
                        </OverlayTrigger>
                      ) : (
                        <XCircle
                          size={24}
                          weight="fill"
                          color="#f02727"
                        />
                      )}
                    </td>
                    <td>
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        <OverlayTrigger
                          overlay={<Tooltip>Visualizar Detalhes</Tooltip>}
                        >
                          <CustomButton onClick={() => handleSelectOs(o)}>
                            <Eye weight="fill" />
                          </CustomButton>
                        </OverlayTrigger>

                        <OverlayTrigger overlay={<Tooltip>Estornar</Tooltip>}>
                          <CustomButton
                            isDelete
                            isLoading={isReverseLoading[i]}
                            onClick={() =>
                              Ask(
                                'Você deseja estornar a OS? Essa ação é irreversível!',
                                () => handleReverseOs(o, i),
                              )
                            }
                          >
                            <ArrowCounterClockwise weight="fill" />
                          </CustomButton>
                        </OverlayTrigger>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>

            <Paginate />
          </>
        )}
      </Container>

      {isModalOsInfoOpen && (
        <ModalInfo
          isOpen={isModalOsInfoOpen}
          onClose={() => setIsModalOsInfoOpen(false)}
          os={osInfo}
        />
      )}

      {isModalFuncOpen && (
        <ModalFunc
          isOpen={isModalFuncOpen}
          onClose={() => setIsModalFuncOpen(false)}
          selectedOs={selectedOs}
          onSuccess={() => {
            toast.success('OS atribuída(s) com sucesso')
            setSelectedOs([])
            setIsModalFuncOpen(false)
            loadOs()
          }}
          loadOs={loadOs}
        />
      )}
    </>
  )
}

export default Os
